import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import cx from "classnames"
import * as React from "react"

export interface ScrollCtaProps {
  className?: string
  cta?: string
  invertColor?: boolean
  arrowSize?: "md" | "lg"
}

const ScrollCta: React.FC<ScrollCtaProps> = ({
  className,
  cta,
  invertColor,
  arrowSize = "md",
}) => {
  const [ref, inView, entry] = useInView({ threshold: 1 })

  return (
    <>
      <div className={styles.scrollRef} ref={ref} />
      <button
        className={cx({
          [className]: !!className,
          [styles.scrollCta]: true,
          [styles.text]: !!cta,
          [styles.invert]: invertColor,
          [styles.isScrolled]: !inView,
        })}
      >
        <div className={styles.inner}>
          {cta && <div className={styles.text}>{cta}</div>}
          <i
            className={cx({
              [styles.arrow]: true,
              [styles.text]: !!cta,
              [styles[arrowSize]]: arrowSize,
            })}
          />
        </div>
      </button>
    </>
  )
}

export default ScrollCta
